import { ModulePlaceholder } from "@/components/common/ModulePlaceholder";
import { useI18n } from "@/i18n/I18nProvider";

export default function StatistiquesPage() {
  const { t } = useI18n();
  return (
    <ModulePlaceholder
      testId="statistiques-page"
      title={t.modules.statistiques.title}
      subtitle={t.modules.statistiques.subtitle}
      body={t.modules.statistiques.body}
      capabilities={[
        "Indicateurs de volume et de délais par période",
        "Répartition des commandes par statut métier",
        "Tous les agrégats doivent être fournis par le backend",
      ]}
      backendEndpoints={[
        "GET /dashboard/resume (10 KPI)",
        "GET /dashboard/alertes",
        "GET /dashboard/commandes-ouvertes",
      ]}
      missingEndpoints={[
        "Endpoint backend supplémentaire requis : séries temporelles agrégées pour les graphiques (ex. GET /statistiques/...)",
      ]}
    />
  );
}
